import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  TableContainer,
  Pagination,
  Stack,
  Paper,
  TextField,
  InputAdornment,
  Chip
} from "@mui/material";
import { format } from "date-fns";
import { Notification } from "../../utils/Notification";
import ScaleLoader from "react-spinners/ScaleLoader";
import useStyles from "../../assets/styles/SupMangComp.style";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import noTableData from "../../assets/images/noTableData.svg";
import CloseIcon from "@mui/icons-material/Close";
import API from "../../../src/utils/Axios.utils";
import useDebounce from "../../utils/useDebounce";
import CustomModel from "../../utils/CustomModel";
import useAuth from "../../hooks/useAuth";

const SkillMangComp = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [skillData, setSkillData] = useState([]);
  console.log('skillData :- ', skillData);

  const [update, setUpdate] = React.useState(0);

  // Snackbar
  const [alert, setAlert] = React.useState(false);
  const [alertContent, setAlertContent] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  // Pagination
  // To do set total data count of api
  const [listCount, setListCount] = useState(0);
  const [page, setPage] = useState(1);

  const handleAlert = () => {
    setAlert(false);
  };

  const handlePageChange = (e, value) => {
    setPage(value);
  };

  const handleNavigate = () => {
    navigate("/skills/addSkill");
  };

  const debouncedQueryList = useDebounce(searchText, 500);

  const { token } = useAuth();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getSkill = async () => {
    setShowLoader(true);
    let url = `/api/core-skill/allcoreSkills?page=${page}&pageSize=10`;

    if (searchText !== "") {
      url += `&search=${debouncedQueryList}`;
    }

    try {
      const res = await API.get(url, config);
      setShowLoader(false);
      setSkillData(res?.data?.coreSkills);
      setListCount(res?.data?.totalCount);
    } catch (error) {
      setShowLoader(false);
      setAlertContent(error?.response?.data?.message);
      setAlertType("error");
      setAlert(true);
    }
  };

  useEffect(() => {
    getSkill();
  }, [page, debouncedQueryList, update]);

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid
        container
        xs={12}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          variant="contained"
          aria-haspopup="true"
          onClick={handleNavigate}
          style={{ background: "#2777AA", width: "214px" }}
        >
          + Add Skill
        </Button>
      </Grid>
      <Grid container xs={12} style={{ marginTop: "2%" }}>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <span className={classes.headingText}>Skill</span>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <TextField
            name="search"
            label="Search by Core Skill"
            variant="outlined"
            size="small"
            style={{ backgroundColor: "#fff", width: 230 }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: searchText !== "" && (
                <InputAdornment position="end">
                  <IconButton>
                    <CloseIcon onClick={() => setSearchText("")} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      <Grid container xs={12} className={classes.tableGrid}>
        {showLoader ? (
          <div
            style={{
              display: "flex",
              height: 400,
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <ScaleLoader size={250} color={"#0576DC"} loading={showLoader} />
          </div>
        ) : skillData?.length === 0 ? (
          <div
            style={{
              height: 300,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img src={noTableData} width={60} alt="No Data" />
            <div
              style={{
                marginTop: 5,
                fontWeight: "500",
                fontSize: 25,
                fontFamily: "'Noto Sans', sans-serif",
              }}
            >
              There are no recent Skills to show.
            </div>
          </div>
        ) : (
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow className={classes.tableHeadRow}>
                  <TableCell className={classes.tableHeadCell}>
                    Core Skill
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>Technical Skill</TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    Created Date
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    Status
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <>
                <TableBody className={classes.noHorizontalBorderTableRow}>
                  {skillData?.map((val) => {
                    return (
                      <TableRow>
                        <TableCell className={classes.tableBodyCell}>
                          <h4>{val.name}</h4>
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          {val.techSkills.length > 0 ? (

                            val?.techSkills?.map((tech) => (
                              <Chip
                                key={tech.id}
                                label={tech.name}
                                size="small"
                                style={{ marginRight: 4, marginBottom: 4 }}
                              />
                            ))

                          ) : (
                            <h4>No data Available</h4>
                          )}

                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          {val.createdAt ? format(new Date(val.createdAt), "dd-MM-yyyy") : '-'}
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          {val.isActive === "Y" ? "Active" : "Inactive"}
                        </TableCell>
                        <TableCell>
                          <JobMoreMenu
                            details={val}
                            navigate={navigate}
                            setUpdate={setUpdate}
                            update={update}
                            setAlertContent={setAlertContent}
                            setAlertType={setAlertType}
                            setAlert={setAlert}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </>
            </Table>
            <Stack
              spacing={2}
              sx={{
                padding: 2,
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              <Pagination
                classes={{
                  root: classes.pagination,
                }}
                count={Math.ceil(listCount / 10)}
                page={page}
                onChange={handlePageChange}
                showFirstButton
                showLastButton
              />
            </Stack>
          </TableContainer>
        )}
      </Grid>
      <Notification
        message={alertContent}
        open={alert}
        severity={alertType}
        onClose={handleAlert}
      />
    </div>
  );
};

export default SkillMangComp;

function JobMoreMenu({
  details,
  navigate,
  update,
  setUpdate,
  setAlertContent,
  setAlertType,
  setAlert,
}) {
  const [delOpen, setDelOpen] = React.useState(false);

  const refDel = React.useRef(delOpen);

  const handleDialogdel = () => {
    setDelOpen(!delOpen);
  };

  const { token } = useAuth();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const handleSkillDelete = () => {
    API.delete(`/api/core-skill/${details.id}`, config)
      .then((res) => {
        handleDialogdel();
        setUpdate(update + 1);
        setAlertContent(res?.data?.message);
        setAlertType("success");
        setAlert(true);
      })
        .catch((error) => {
        const errorData = error?.response?.data;
        let errorMessage = errorData?.message || errorData?.error || 'Failed to delete core skill';

        setAlertContent(errorMessage);
        setAlertType("error");
        setAlert(true);
      });
    // .catch((error) => {
    //   setAlertContent(error?.response?.data?.message);
    //   setAlertType("error");
    //   setAlert(true);
    // });
  };
  return (
    <>
      {/* /editJob */}

      <IconButton
        onClick={() => {
          navigate("/skills/editSkill", { state: { skillDetails: details } });
        }}
      >
        <EditIcon sx={{ color: "#2777AA" }} />
      </IconButton>

      <CustomModel
        handleDialog={handleDialogdel}
        open={delOpen}
        title="Delete Skill"
      >
        <div
          style={{
            textAlign: "center",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontSize: "24px",
          }}
        >
          Do you want to delete the Skill?
        </div>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "1em",
              gap: "10px",
            }}
          >
            <Button
              variant="contained"
              onClick={() => handleSkillDelete(details?.job_id)}
              style={{ background: "#2777AA" }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={() => handleDialogdel()}
              style={{ background: "#2777AA" }}
            >
              NO
            </Button>
          </div>
        </Grid>
      </CustomModel>

      <IconButton
        ref={refDel}
        onClick={() => {
          setDelOpen(true);
        }}
      >
        <DeleteIcon sx={{ color: "red" }} />
      </IconButton>
    </>
  );
}
